$(function () {

  // 点击出现弹窗
  ewmFadeIn(".banner-btn")
  ewmFadeIn(".hidden-nav .nav-box .nav-item:last")
  ewmFadeIn("#navBox .nav-item:last")

  $(".ewm .guanbi").click(function () {
    $(".ewm").fadeOut()
  })

  function ewmFadeIn(err) {
    $(err).click(function () {
      $(".ewm").fadeIn();
    });
  }
 
  // 首页轮播图
  new Swiper("#banner1", {
    autoplay: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  new Swiper("#banner2", {
    autoplay: true,
    loop: true,
    pagination: {
      el: ".moment-pagination"
    }
  });

  new Swiper("#banner3", {
    // autoplay: true,
    loop: true,
    pagination: {
      el: ".judge-pagination"
    }
  });
  // 活动动态  轮播
  new Swiper("#teacherSwiper", {
    autoplay: true,
    loop: true,

    pagination: {
      el: '.teacherPagination',
    },

  });



  $(".form-content").listenForm({
    listenName: "立即报名",
    submitTarget: ".baomin-btn",
    cityRequired: true
  }); // footer


  // 报名人数
  setInterval(
    $.ajax({
      url: "https://www.xhd.cn/getApplyAmount.jspx",
      data: {
        appId: 1
      },
      type: "POST",
      success: function (res) {
        let personNum = String(res.applyAmount).split("");
        let _html = "";
        personNum.map(i => {
          _html += `<i class="num">${i}</i> `;
        });
        $(".applyAmount .numbox").append(_html);
      }
    }),
    600000
  );


  // 评审规则
  $(".rules-nav .nav-list").click(function () {
    console.log(21)
    $(this).addClass("activeItem").siblings().removeClass("activeItem")
    $(".rules-list").eq($(this).index()).show().siblings().hide()
  })

 
 // 导航栏滚动
 var topNav = $("#navBox").offset().top;
 $(document).scroll(function () {
   var windowTop = $(document).scrollTop();
   if (windowTop > topNav) {
     $(".hidden-nav").show();
   } else {
     $(".hidden-nav").hide();
   }
 });
});